import '@shui/core/sh-badge';

import { Component, booleanAttribute, input, ChangeDetectionStrategy } from '@angular/core';

export type ShBadgeSize = 'small' | 'medium';
export type ShBadgeType = 'error' | 'warning' | 'success';
export type ShBadgeVariant = 'rounded' | 'squared';

@Component({
    selector: 'sh-badge',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.label]': 'label() ?? null',
        '[attr.size]': 'size() ?? null',
        '[attr.type]': 'type() ?? null',
        '[attr.variant]': 'variant() ?? null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.neutral]': 'neutral() ? "" : null',
        '[attr.show-label]': 'showLabel() ? "" : null'
    }
})
export class ShBadgeComponent {
    /** Number or short text shown inside the badge (max 4 digits for numbers). */
    public readonly label = input<string | undefined>(undefined);

    /** Badge size. Default SHUI value is `'small'`. */
    public readonly size = input<ShBadgeSize | undefined>(undefined);

    /** Status type — sets color and icon. */
    public readonly type = input<ShBadgeType | undefined>(undefined);

    /** Corner radius style. Default SHUI value is `'rounded'`. */
    public readonly variant = input<ShBadgeVariant | undefined>(undefined);

    /** Applies disabled styles. */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /** Applies neutral styles (grey palette). */
    public readonly neutral = input(false, { transform: booleanAttribute });

    /**
     * Shows the `label` text alongside the `type` icon.
     * Has no effect unless `type` is also set.
     */
    public readonly showLabel = input(false, { transform: booleanAttribute });
}
